import { useState } from "react";
import { cn } from "@/lib/utils";
import { resolveImg } from "@/lib/api";

export const SmartImage = ({ src, alt, className, fallbackLabel, fit = "cover" }) => {
  const [error, setError] = useState(false);
  const resolved = resolveImg(src);

  if (error || !resolved) {
    return (
      <div
        className={cn(
          "flex h-full w-full items-center justify-center bg-gradient-to-br from-[hsl(168_30%_90%)] via-[hsl(36_35%_93%)] to-[hsl(24_45%_90%)] px-4 text-center",
          className
        )}
      >
        <span className="font-display text-base font-semibold text-primary/70">
          {fallbackLabel || "Ecentra"}
        </span>
      </div>
    );
  }

  return (
    <img
      src={resolved}
      alt={alt}
      loading="lazy"
      onError={() => setError(true)}
      className={cn("h-full w-full", fit === "contain" ? "object-contain" : "object-cover", className)}
    />
  );
};
